<template>
  <div class="status" :class="{ 'use-bg': useBackgroundColor }" :style="styles">
    <p v-if="isSuccessful" class="success-txt">
      {{ isSuccessful }}
    </p>

    <p v-else-if="isReconciled" class="success-txt">
      {{ isReconciled }}
    </p>

    <p v-else-if="isReversal" class="pending-txt">
      {{ isReversal }}
    </p>

    <p v-else-if="isPending" class="pending-txt">
      {{ isPending }}
    </p>

    <p v-else-if="isUnreconciled" class="failed-txt">
      {{ isUnreconciled }}
    </p>

    <p v-else-if="isFailed" class="failed-txt">
      {{ isFailed }}
    </p>

    <p v-else-if="isCancelled" class="failed-txt">
      {{ isCancelled }}
    </p>

    <p v-else-if="isProcessing" class="processing-txt">
      {{ isProcessing }}
    </p>

    <p v-else class="unknown-txt">
      {{ unknownStatus ? unknownStatus : "N/A" }}
    </p>
  </div>
</template>
<script>
import startCase from "lodash/startCase";

export default {
  name: "StatusIndicatorWithWordsV2",
  props: {
    type: String,
    styles: String,
    useBackgroundColor: Boolean,
  },

  computed: {
    isSuccessful() {
      const value = [
        "successful",
        "settled",
        "active",
        "completed",
        "up",
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      const data = value ? this.type.toString().toLowerCase() : false;
      const status = startCase(data === "active" ? "successful" : data);
      return data ? status : data;
    },
    isReconciled() {
      const value = [
        "reconciled",
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      const data = value ? this.type.toString().toLowerCase() : false;
      const status = startCase(data === "active" ? "successful" : data);
      return data ? status : data;
    },

    isUnreconciled() {
      const value = [
        "unreconciled",
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      const data = value ? this.type.toString().toLowerCase() : false;
      const status = startCase(data === "active" ? "successful" : data);
      return data ? status : data;
    },

    isFailed() {
      const value = [
        "inactive",
        "failed",
        "stop",
        "unsettled",
        "down",
        "declined",
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      const data = value ? this.type.toString().toLowerCase() : false;
      const status = startCase(data === "active" ? "successful" : data);
      return data ? status : data;
    },

    isReversal() {
      const value = [
        "reversal"
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      return value
          ? startCase(this.type.toString().toLowerCase().replace("_", " "))
          : false;
    },

    isPending() {
      const value = [
        "pending",
        "pending_customer_approval",
        "pending_kyc_review",
        "stop",
        "inq",
        "scheduled",
      ].includes(this.type ? this.type.toString().toLowerCase() : "");
      return value
          ? startCase(this.type.toString().toLowerCase().replace("_", " "))
          : false;
    },

    isProcessing() {
      const value = ["processing", "unstable"].includes(
          this.type ? this.type.toString().toLowerCase() : ""
      );

      return value
          ? startCase(this.type.toString().toLowerCase().replace("_", " "))
          : false;
    },

    isCancelled() {
      const value = ["cancelled", "stopped"].includes(
          this.type ? this.type.toString().toLowerCase() : ""
      );
      return value ? startCase(this.type.toString().toLowerCase()) : false;
    },

    unknownStatus() {
      return this.type
          ? startCase(this.type.toString().toLowerCase().replace("_", " "))
          : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  text-align: center;
  & > * {
    padding: 5px 8px;
  }
  span {
    color: transparent;
  }

  .success-txt {
    color: #15ce9a !important;
  }

  .pending-txt {
    color: #ffce31 !important;
  }

  .processing-txt {
    color: #17a0fb !important;
  }

  .failed-txt {
    color: #c61211 !important;
  }

  .unknown-txt {
    color: #030d18 !important;
  }

  &.use-bg {
    text-align: center;

    p {
      padding: 9px;
      border-radius: 2px;
      //max-width: 5.968rem;
    }

    .success-txt {
      background: #e3f7ee;
    }

    .pending-txt {
      background: #fff4da;
    }

    .processing-txt {
      background: rgba(23, 160, 251, 0.15);
    }

    .failed-txt {
      background: #fce9ea;
    }

    .unknown-txt {
      background: rgba(3, 13, 24, 0.15);
    }
  }
}
</style>
